export enum EventBookingSource {
  App = "app",
  Staff = "staff",
  None = ""
}
